import { Link } from "react-router";
import { Avatar } from "@/components/common/Avatar";

export interface SharedItemAuthorPerson {
  id: string;
  avatarContent?: string | null;
  avatarMime?: string | null;
}

export function SharedItemAuthor({ person, name }: { person?: SharedItemAuthorPerson | null; name: string }) {
  const content = (
    <>
      <Avatar
        person={{
          name,
          avatarContent: person?.avatarContent,
          avatarMime: person?.avatarMime,
        }}
        size="lg"
      />
      <span className={`text-sm font-medium${person ? " transition group-hover:text-accent" : ""}`}>{name}</span>
    </>
  );

  if (!person) return <div className="flex items-center gap-3">{content}</div>;

  return (
    <Link
      to={`/p/${person.id}`}
      className="group flex w-fit items-center gap-3 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-ink/30"
    >
      {content}
    </Link>
  );
}
